import { createHashRouter, RouterProvider } from "react-router-dom";
import { Suspense, lazy } from "react";
import Loader from "./utils/Loader/Loader";

// Lazy imports
const Layout = lazy(() => import("./Components /Layout/Layout"));
const HomePage = lazy(() => import("./pages/HomePage/HomePage"));
const OurTeam = lazy(() => import("./pages/Team/OurTeam"));
const AboutUs = lazy(() => import("./pages/AboutUs/AboutUs"));
const ServicesAndSolutions = lazy(() =>
  import("./pages/ServicesAndSolutions/ServicesAndSolutions")
);
const AIEngineering = lazy(() =>
  import("./pages/AI Engineering/AIEngineering")
);
const CRMSolutions = lazy(() => import("./pages/CRM Solutions/CRMSolutions"));
const DataSecurity = lazy(() => import("./pages/Data Security/DataSecurity"));
const RoboticAutomation = lazy(() =>
  import("./pages/RoboticAutomation/RoboticAutomation")
);
const ContainersCloudSolutions = lazy(() =>
  import("./pages/ContainersCloudSolutions/ContainersCloudSolutions")
);
const DevopsCICDSolutions = lazy(() =>
  import("./pages/DevopsCICDSolutions/DevopsCICDSolutions")
);
const MicroservicesSolutions = lazy(() =>
  import("./pages/MicroservicesSolutions/MicroservicesSolutions")
);
const NoSQLSolutions = lazy(() =>
  import("./pages/NoSQLSolutions/NoSQLSolutions")
);
const IOTSolutions = lazy(() => import("./pages/IOTSolutions/IOTSolutions"));
const ETLStreamingSolutions = lazy(() =>
  import("./pages/ETLStreamingSolutions/ETLStreamingSolutions")
);
const EntertainmentSolutions = lazy(() =>
  import("./pages/EntertainmentSolutions/EntertainmentSolutions")
);
const HRSystems = lazy(() => import("./pages/HRSystems/HRSystems"));
const UIUXProductDesign = lazy(() =>
  import("./pages/UIUXProductDesign/UIUXProductDesign")
);
const LeadingBeverageStudy = lazy(() =>
  import("./pages/CaseStudies/LeadingBeverageStudy/LeadingBeverageStudy")
);
const CRMListeningStudy = lazy(() =>
  import("./pages/CaseStudies/CRMListeningStudy/CRMListeningStudy")
);
const SocialMediaStudy = lazy(() =>
  import("./pages/CaseStudies/SocialMediaStudy/SocialMediaStudy")
);
const OptimisingECommerceStudy = lazy(() =>
  import(
    "./pages/CaseStudies/OptimisingECommerceStudy/OptimisingECommerceStudy"
  )
);
const NotFoundPage = lazy(() => import("./pages/NotFoundPage/NotFoundPage"));

export default function Router() {
  const router = createHashRouter([
    {
      path: "/",
      element: (
        <Suspense fallback={<Loader />}>
          <Layout />
        </Suspense>
      ),
      children: [
        {
          path: "/",
          element: (
            <Suspense fallback={<Loader />}>
              <HomePage />
            </Suspense>
          ),
        },
        {
          path: "/ourTeam",
          element: (
            <Suspense fallback={<Loader />}>
              <OurTeam />
            </Suspense>
          ),
        },
        {
          path: "/aboutUs",
          element: (
            <Suspense fallback={<Loader />}>
              <AboutUs />
            </Suspense>
          ),
        },
        {
          path: "/solutions",
          element: (
            <Suspense fallback={<Loader />}>
              <ServicesAndSolutions />
            </Suspense>
          ),
        },
        {
          path: "/aiEngineering",
          element: (
            <Suspense fallback={<Loader />}>
              <AIEngineering />
            </Suspense>
          ),
        },
        {
          path: "/crmSolutions",
          element: (
            <Suspense fallback={<Loader />}>
              <CRMSolutions />
            </Suspense>
          ),
        },
        {
          path: "/dataSecurity",
          element: (
            <Suspense fallback={<Loader />}>
              <DataSecurity />
            </Suspense>
          ),
        },
        {
          path: "/roboticAutomation",
          element: (
            <Suspense fallback={<Loader />}>
              <RoboticAutomation />
            </Suspense>
          ),
        },
        {
          path: "/containersCloudSolutions",
          element: (
            <Suspense fallback={<Loader />}>
              <ContainersCloudSolutions />
            </Suspense>
          ),
        },
        {
          path: "/devopsCICDSolutions",
          element: (
            <Suspense fallback={<Loader />}>
              <DevopsCICDSolutions />
            </Suspense>
          ),
        },
        {
          path: "/microservicesSolutions",
          element: (
            <Suspense fallback={<Loader />}>
              <MicroservicesSolutions />
            </Suspense>
          ),
        },
        {
          path: "/noSQLSolutions",
          element: (
            <Suspense fallback={<Loader />}>
              <NoSQLSolutions />
            </Suspense>
          ),
        },
        {
          path: "/iotSolutions",
          element: (
            <Suspense fallback={<Loader />}>
              <IOTSolutions />
            </Suspense>
          ),
        },
        {
          path: "/etlStreamingSolutions",
          element: (
            <Suspense fallback={<Loader />}>
              <ETLStreamingSolutions />
            </Suspense>
          ),
        },
        {
          path: "/entertainmentSolutions",
          element: (
            <Suspense fallback={<Loader />}>
              <EntertainmentSolutions />
            </Suspense>
          ),
        },
        {
          path: "/hrSystems",
          element: (
            <Suspense fallback={<Loader />}>
              <HRSystems />
            </Suspense>
          ),
        },
        {
          path: "/uiuxProductDesign",
          element: (
            <Suspense fallback={<Loader />}>
              <UIUXProductDesign />
            </Suspense>
          ),
        },
        {
          path: "/beverageCaseStudy",
          element: (
            <Suspense fallback={<Loader />}>
              <LeadingBeverageStudy />
            </Suspense>
          ),
        },
        {
          path: "/crmListeningCaseStudy",
          element: (
            <Suspense fallback={<Loader />}>
              <CRMListeningStudy />
            </Suspense>
          ),
        },
        {
          path: "/socialMediaStudy",
          element: (
            <Suspense fallback={<Loader />}>
              <SocialMediaStudy />
            </Suspense>
          ),
        },
        {
          path: "/eCommerceStudy",
          element: (
            <Suspense fallback={<Loader />}>
              <OptimisingECommerceStudy />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "*",
      element: (
        <Suspense fallback={<Loader />}>
          <NotFoundPage />
        </Suspense>
      ),
    },
  ]);

  return <RouterProvider router={router} />;
}
